var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 24H13.5C13.925 24 14.2813 23.8562 14.5688 23.5687C14.8563 23.2812 15 22.925 15 22.5V21L18 22.575V16.425L15 18V16.5C15 16.075 14.8563 15.7187 14.5688 15.4312C14.2813 15.1437 13.925 15 13.5 15H7.5C7.075 15 6.71875 15.1437 6.43125 15.4312C6.14375 15.7187 6 16.075 6 16.5V22.5C6 22.925 6.14375 23.2812 6.43125 23.5687C6.71875 23.8562 7.075 24 7.5 24ZM3 30C2.175 30 1.46875 29.7062 0.88125 29.1187C0.29375 28.5312 0 27.825 0 27V2.99998C0 2.17498 0.29375 1.46873 0.88125 0.881235C1.46875 0.293735 2.175 -1.52588e-05 3 -1.52588e-05H15L24 8.99998V27C24 27.825 23.7063 28.5312 23.1188 29.1187C22.5312 29.7062 21.825 30 21 30H3ZM13.5 10.5V2.99998H3V27H21V10.5H13.5Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.69f7bd27cf1e0d55c36e71ec23a53d71.svg";
export { ForwardRef as ReactComponent };